import { GaEvents } from '@porterin/booking-flow/src/auth/view/stores/AuthAnalyticsStore';
import { mapPageToCategory } from '@porterin/booking-flow/src/utils/BookingFlowAnalyticsHelper';
import { Button } from '@porterin/component-library/src/base-components';
import { publishEvent } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Image from 'next/image';
import { useState } from 'react';

import { RESEND_OTP_CONFIG } from '../../../domain/config/otp';
import { ResendOtpOption } from '../../../domain/entities/ResendOtpOption';
import { useAuthContentContext } from '../../contexts/auth-content/AuthContentContext';

export interface ResendOptionsCmpProps {
  on_resend: (option: ResendOtpOption) => void;
}

const RESEND_ICON_SIZE = 28;

const ResendOptionsCmp: React.FC<ResendOptionsCmpProps> = ({ on_resend }) => {
  const { resendOptionsModal } = useAuthContentContext();
  const [selectedOption, setSelectedOption] = useState<ResendOtpOption | null>(
    null,
  );

  return (
    <div>
      <div id="resend-options">
        {resendOptionsModal.options.map(option => (
          <div
            key={option.value}
            className={`flex items-center outline p-[1.2rem] my-[2rem] rounded-[0.8rem] ${selectedOption === option.value ? 'outline-[#0A57FF] outline-[0.2rem]' : 'outline-[#4e525b1f] outline-[0.1rem]'}`}
            onClick={() => setSelectedOption(option.value)}
            id={`resend-option-${option.value}`}
          >
            <Image
              src={option.icon.path}
              alt={option.icon.altText}
              width={RESEND_ICON_SIZE}
              height={RESEND_ICON_SIZE}
            />
            <div className="ml-[1.2rem]">
              <div className="text-[1.4rem] font-semibold text-[#2d2f34]">
                {option.text}
              </div>
              <div className="text-[1.2rem] text-[#5f636d]">
                {option.subText}
              </div>
            </div>
            <div
              className={`w-8 h-8 ml-auto p-[0.3rem] border-[0.1rem] rounded-full ${selectedOption === option.value ? 'border-[#0A57FF]' : 'border-[#707582]'}`}
            >
              <div
                className={`w-full h-full rounded-full ${selectedOption === option.value ? 'bg-[#0A57FF]' : 'bg-white'}`}
              />
            </div>
          </div>
        ))}
      </div>
      <Button
        className={`bg-[#0A57FF] text-typography-primary-inverse font-copy-lg font-semibold sm:mt-3 w-full ${!selectedOption ? 'bg-[#ecedee] text-[#9499a3]' : ''}`}
        identifiers={{ id: 'resend-option-btn' }}
        disabled={!selectedOption}
        interactions={{
          onClick: () => {
            publishEvent({
              category: mapPageToCategory(window.location.pathname),
              action: GaEvents.resendOtpCtaTap,
              label: selectedOption === 'SMS' ? 'SMS' : 'WhatsApp',
            });
            on_resend(selectedOption || RESEND_OTP_CONFIG.DEFAULT_OPTION);
          },
        }}
      >
        {resendOptionsModal.confirmCta}
      </Button>
    </div>
  );
};

export default ResendOptionsCmp;
